import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import React from 'react';
import { formatDataRateSmart } from "kontrolEdge/helpers/formatDataRate";

  interface CapacityAllocationChartProps {
    data: {
      name: string;
      value: number;
      color: string;
    }[];
  }
  
  export function CapacityAllocationChart({ data }: CapacityAllocationChartProps) {
    const totalCapacity = data.reduce((sum, item) => sum + item.value, 0);
  
    return (
      <div style={{ height: '200px' }} className="relative">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius="60%"
              outerRadius="90%"
              paddingAngle={0}
              dataKey="value"
              strokeWidth={0}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
  
        {/* Center text */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <span className="text-gray-500 text-sm">Total</span>
          <span className="text-lg font-semibold">{formatDataRateSmart(totalCapacity)}</span>
        </div>
      </div>
    );
  }
  


